import { useState, useEffect } from "react";
import axios from "axios";

export default function useObtenerMunProp(usuario, propuestaId) {
  const [error, guardarError] = useState(false);
  const [municipio, guardarMunicipio] = useState(undefined);
  const [propuesta, guardarPropuesta] = useState(undefined);

  useEffect(() => {
    if (usuario !== undefined) {
      const obtenerMunicipio = () => {
        axios
          .get(`/api/municipios/${usuario.municipioId}`)
          .then((res) => {
            guardarMunicipio(res.data.municipio);
          })
          .catch((error) => guardarError(true));
      };
      obtenerMunicipio();

      const obtenerPropuesta = () => {
        axios
          .get(`/api/propuestas/auth/${propuestaId}`)
          .then((res) => {
            guardarPropuesta(res.data.propuesta);
          })
          .catch((error) => guardarError(true));
      };
      obtenerPropuesta();
    }
    return () => {
      guardarMunicipio(undefined);
      guardarPropuesta(undefined);
    };
  }, [usuario, propuestaId]);

  return [municipio, propuesta, error];
}
